module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_12.253cf991.mp3";